import { EntityType } from '@polyai/stream/store/reducers/entities/types';

import { ENTITY_SIDEBAR_UI_COPY } from './EntitySidebar.uiCopy';

export const DEFAULT_ENTITY_TYPE = EntityType.FREE_TEXT;

export const COUNTRY_CODES = [
  'US', // United States
  'CA', // Canada
  'MX', // Mexico
  'BR', // Brazil
  'GB', // United Kingdom
  'IE', // Ireland
  'FR', // France
  'DE', // Germany
  'ES', // Spain
  'IT', // Italy
  'NL', // Netherlands
  'BE', // Belgium
  'CH', // Switzerland
  'AT', // Austria
  'SE', // Sweden
  'NO', // Norway
  'DK', // Denmark
  'FI', // Finland
  'PL', // Poland
  'CZ', // Czech Republic
  'HU', // Hungary
  'PT', // Portugal
  'GR', // Greece
  'SG', // Singapore
  'HK', // Hong Kong
  'AU', // Australia
];

export const ISO_TO_PHONE_CODE: Record<string, string> = {
  US: '+1', // United States
  CA: '+1', // Canada
  MX: '+52', // Mexico
  BR: '+55', // Brazil
  GB: '+44', // United Kingdom
  IE: '+353', // Ireland
  FR: '+33', // France
  DE: '+49', // Germany
  ES: '+34', // Spain
  IT: '+39', // Italy
  NL: '+31', // Netherlands
  BE: '+32', // Belgium
  CH: '+41', // Switzerland
  AT: '+43', // Austria
  SE: '+46', // Sweden
  NO: '+47', // Norway
  DK: '+45', // Denmark
  FI: '+358', // Finland
  PL: '+48', // Poland
  CZ: '+420', // Czech Republic
  HU: '+36', // Hungary
  PT: '+351', // Portugal
  GR: '+30', // Greece
  SG: '+65', // Singapore
  HK: '+852', // Hong Kong
  AU: '+61', // Australia
};

export const ENTITY_TYPE_OPTIONS = [
  {
    label: ENTITY_SIDEBAR_UI_COPY.entityTypeOptions.phone_number,
    value: EntityType.PHONE_NUMBER,
  },
  {
    label: ENTITY_SIDEBAR_UI_COPY.entityTypeOptions.number,
    value: EntityType.NUMERIC,
  },
  {
    label: ENTITY_SIDEBAR_UI_COPY.entityTypeOptions.date,
    value: EntityType.DATE,
  },
  {
    label: ENTITY_SIDEBAR_UI_COPY.entityTypeOptions.time,
    value: EntityType.TIME,
  },
  {
    label: ENTITY_SIDEBAR_UI_COPY.entityTypeOptions.free_text,
    value: EntityType.FREE_TEXT,
  },
  {
    label: ENTITY_SIDEBAR_UI_COPY.entityTypeOptions.multiple_choice,
    value: EntityType.ENUM,
  },
  {
    label: ENTITY_SIDEBAR_UI_COPY.entityTypeOptions.name,
    value: EntityType.NAME,
  },
  {
    label: ENTITY_SIDEBAR_UI_COPY.entityTypeOptions.address,
    value: EntityType.ADDRESS,
  },
  {
    label: ENTITY_SIDEBAR_UI_COPY.entityTypeOptions.alphanumeric,
    value: EntityType.ALPHANUMERIC,
  },
];
